var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b_login"},[_c('div',{staticClass:"login_form_wrapper"},[_c('div',{staticClass:"login_form_inner"},[_c('nuxt')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }